import {
  MUSIC_LESSON_FORMAT_VALUES,
  MUSIC_PHYSICAL_VENUE_VALUES,
  type MusicLessonFormat,
  type MusicPhysicalVenue,
} from '@tutor/types';

export const MUSIC_INSTRUMENTS = [
  'Piano', 'Keyboard', 'Violin', 'Viola', 'Cello', 'Guitar', 'Bass Guitar',
  'Ukulele', 'Drums', 'Flute', 'Recorder', 'Clarinet', 'Saxophone', 'Trumpet',
  'Voice', 'Music Theory',
];

export const MUSIC_LEVELS = [
  'Beginner', 'Grade 1-2', 'Grade 3-5',
  'Grade 6-8', 'Diploma', 'Advanced',
];

export const MUSIC_AGE_GROUPS = [
  'Early childhood (3-5)', 'Children (6-12)', 'Teenagers (13-17)',
  'Adults (18-59)', 'Seniors (60+)',
];

export const MUSIC_EXAM_BOARDS = [
  'ABRSM', 'Trinity College London', 'Rockschool', 'LCM', 'AMEB', 'Yamaha',
];

export const MUSIC_LEARNING_GOALS = [
  'Learn for enjoyment', 'Build strong fundamentals', 'Prepare for graded exams',
  'Prepare for auditions or performances', 'Improve technique', 'Learn a specific song',
];

export const MUSIC_TEACHING_LANGUAGES = ['English', 'Malay', 'Mandarin', 'Cantonese', 'Tamil'];

export const MUSIC_LESSON_FORMATS = [
  { value: MUSIC_LESSON_FORMAT_VALUES[0], label: 'One-to-one' },
  { value: MUSIC_LESSON_FORMAT_VALUES[1], label: 'Group lesson' },
] as const satisfies ReadonlyArray<{ value: MusicLessonFormat; label: string }>;

export const MUSIC_PHYSICAL_VENUES = [
  { value: MUSIC_PHYSICAL_VENUE_VALUES[0], label: "Student's home" },
  { value: MUSIC_PHYSICAL_VENUE_VALUES[1], label: "Tutor's studio" },
] as const satisfies ReadonlyArray<{ value: MusicPhysicalVenue; label: string }>;

export const MUSIC_QUALIFICATION_TYPES = [
  'Graded examination', 'Diploma', 'Degree', 'Teaching certificate', 'Professional training',
];

export const MUSIC_PORTFOLIO_TYPES = ['Performance video', 'Audio recording', 'Profile', 'Other'];
